import SuggestionNode from './SuggestionNode';
import ExtendedSmartComposeInteraction from './ExtendedSmartComposeInteraction';

export const SUGGESTION_CLASS = 'suggestedCompletion';

interface Suggestion {
    suggestionText: string; // the string for the suggestion
    suggestionNode: SuggestionNode; // represents the dom elements inserted in the editor
    suggestionTelemetry: ExtendedSmartComposeInteraction; // reference to the telemetry stored for this suggestion
}

export default Suggestion;
